/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const BaseLTIProviderParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['createdAt', parsers.moment, 'created_at'],
    ['intendedUse', codecString, 'intended_use'],
    ['tenantId', codecString, 'tenant_id'],
    ['label', codecString],
]);
export class BaseLTIProvider extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return BaseLTIProviderParser.decode(input).map(res => new BaseLTIProvider(res));
    }
    static unsafeDecode(input) {
        return BaseLTIProvider.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return BaseLTIProviderParser.encode(data);
    }
    static schema() {
        return BaseLTIProviderParser.schema();
    }
}
